import type { FieldTree } from '@angular/forms/signals';
import { readonly } from '@angular/forms/signals';

import type { BorderRadiusCorners, BorderRadiusSettings, Device } from '@sites/entity-core';
import { borderRadiusFeature } from '@sites/entity-core';
import { writeDevice } from '../../core/write-device';
import { withCorners } from '../../mixins/corners/corners-updaters';

// Thunk is mandatory: see `createBorderAccessors`.
export const createBorderRadiusAccessors = (getField: () => FieldTree<BorderRadiusSettings>) => ({
    get borderRadius() {
        return getField();
    },
    setBorderRadius: (value: Omit<BorderRadiusSettings, 'version'>) => {
        getField()().value.set({ ...value, version: borderRadiusFeature.latestVersion });
    },

    /** The four corners live in one leaf, so a single-corner edit merges into it. */
    setRadius: (patch: Partial<BorderRadiusCorners>, device: Device = 'desktop') => {
        writeDevice(getField().corners, device, withCorners(patch));
    },
});

export type BorderRadiusAccessors = ReturnType<typeof createBorderRadiusAccessors>;

export const applyBorderRadiusFieldRules = (radiusPath: any): void => {
    readonly(radiusPath.version);
};
